import { makeChartComp } from '../../util/makeChartComp';
var PieChart = makeChartComp('Pie');
export default PieChart;
